import React from 'react';
import PropTypes from 'prop-types';
import { Overlay } from 'react-bootstrap';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

export class InputOverlay extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      show: false
    };
    this.openDropdown = this.openDropdown.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onChangeActivity = this.onChangeActivity.bind(this);
  }

  closeDropdown (e) {
    const { idToIgnoreToggle } = this.props;
    const tag = get(e, 'target.id', '');
    if (idToIgnoreToggle !== tag) {
      this.setState({ show: false });
      if (isFunction(this.props.onBlurFn)) this.props.onBlurFn();
    }
  }

  openDropdown (e) {
    this.setState({ show: true });
    if (isFunction(this.props.onFocusFn)) this.props.onFocusFn(e);
  }

  toggleDropdown () {
    const { show } = this.state;
    this.setState({ show: !show });
  }

  onChangeActivity (e) {
    if (e.target.value && !this.state.show) {
      this.openDropdown(e);
    }
    this.props.onChange(e);
  }

  render () {
    const {
      containerClassName,
      inputClassName,
      inputDataValue,
      inputShownValue,
      children,
      inputRef,
      onBlurFn,
      onFocusFn,
      idToIgnoreToggle,
      onChange,
      ...rest
    } = this.props;
    const { show } = this.state;
    const listComponent = React.cloneElement(children, { listToggle: this.toggleDropdown });
    return (
      <div className={`dropdown-container ${containerClassName || ''}`} >
        <input
          aria-haspopup="true"
          tabIndex="0"
          type="text"
          className={`form-control ${inputClassName || ''}`}
          onFocus={this.openDropdown}
          ref={inputRef}
          value={inputShownValue}
          data-value={inputDataValue}
          autoComplete="off"
          onChange={this.onChangeActivity}
          {...rest}
        />
        <Overlay
          container={this}
          show={show}
          placement="bottom"
          target={this.target}
          onHide={this.closeDropdown}
          rootClose
        >
          <div>
            { listComponent }
          </div>
        </Overlay>
      </div>
    );
  }
}

InputOverlay.propTypes = {
  showOverlay: PropTypes.bool,
  inputDataValue: PropTypes.string,
  inputShownValue: PropTypes.string,
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  children: PropTypes.object.isRequired,
  inputRef: PropTypes.func,
  onFocusFn: PropTypes.func,
  onBlurFn: PropTypes.func,
  onChange: PropTypes.func,
  idToIgnoreToggle: PropTypes.string
};
